import React from 'react'
const ButtonComp = ({ ref, onClick, form, name, value, text, className, type, children, disabled }) => {
    return (

        < button ref={ref} disabled={disabled} form={form} type={type} className={className} onClick={(e) => { onClick && onClick(e) }} name={name} value={value} > {text}
            {children}
        </button >)

}

export default ButtonComp